import { Spin } from "antd";
import {LoadingOutlined} from '@ant-design/icons';
import styles from './CustomSpin.module.scss';


export const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

export const CustomSpin: React.FC = () => <Spin className={styles.spin} indicator={antIcon}/>